<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>ユーザー情報</v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex md10>
              <v-text-field v-model="value.name" :rules="nameRules" label="Name" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md10>
              <v-text-field v-model="value.email" :rules="emailRules" label="E-mail" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md10>
              <v-text-field
                v-if="action == 'add'"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                name="input-10-2"
                label="Visible"
                hint="At least 8 characters"
                v-model="value.first_password"
                class="input-group--focused"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md1>
              <v-select :items="['manager','user']" label="役割" v-model="value.role"></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">キャンセル</v-btn>
        <v-btn v-if="action == 'add'" @click="addUser">追加</v-btn>
        <v-btn v-if="action == 'update'" @click="updateUser">更新</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import { FormattedDateTounixtime } from "@/utils/datetime.js";
import InputDate from "@/components/inputDate";
import positions from "@/master/positions.json"
var moment = require("moment-timezone");
moment.tz.setDefault("Asia/Tokyo");

export default {
  components: {
    InputDate
  },
  props: ["value", "action"],
  data() {
    return {
      valid: false,
      name: "",
      nameRules: [v => !!v || "必須事項です"],
      email: "",
      emailRules: [
        v => !!v || "必須事項です",
        v => /.+@.+/.test(v) || "E-mailの形式ではありません。"
      ],
      date: null,
      showPassword: false,
      positionOptions: positions,
      items: [],

    };
  },
  watch: {
    date() {
      this.value.birth = FormattedDateTounixtime(this.date);
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    addUser() {
      this.$emit("createItem");
    },
    updateUser() {
      this.$emit("updateItem");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


